import { JewishMonth, toGregorianDate } from 'jewish-date';

const now = new Date();
const thisYear = now.getFullYear();

export const nextDate = (month: number, day: number): Date => {
  const dayThisYear = new Date(thisYear, month - 1, day);

  if (dayThisYear > now) {
    return dayThisYear;
  }

  return new Date(thisYear + 1, month - 1, day);
};

const easter = (year: number): Date => {
  const C = Math.floor(year / 100);
  const N = year - 19 * Math.floor(year / 19);
  const K = Math.floor((C - 17) / 25);
  let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
  I = I - 30 * Math.floor((I / 30));
  I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
  let J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
  J = J - 7 * Math.floor(J / 7);
  const L = I - J;
  const M = 3 + Math.floor((L + 40) / 44);
  const D = L + 28 - 31 * Math.floor(M / 4);

  return new Date(year, M, D);
};

export const nextEaster = () => {
  const dayThisYear = easter(thisYear);

  if (dayThisYear > now) {
    return dayThisYear;
  }
  return easter(thisYear + 1);
};

const usaThanksgiving = (year: number): Date => {
  const lastOfNov = new Date(year, 10, 30).getDay();
  const day = (lastOfNov >= 4 ? 34 : 27) - lastOfNov;

  return new Date(year, 10, day);
};

export const nextUsaThanksgiving = (): Date => {
  const dayThisYear = usaThanksgiving(thisYear);

  if (dayThisYear > now) {
    return dayThisYear;
  }
  return usaThanksgiving(thisYear + 1);
};

const hanukkah = (gregorianYear: number): Date => {
  return toGregorianDate({
    year: gregorianYear + 3761, // Barely works for Hanukkah because the latest it can be is December 27
    monthName: JewishMonth.Kislev,
    day: 25,
  });
};

export const nextHanukkah = (): Date => {
  const dayThisYear = hanukkah(thisYear);

  if (dayThisYear > now) {
    return dayThisYear;
  }
  return hanukkah(thisYear + 1);
};
